import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import EngagementPage from './EngagementPage';
import DirectoryPage from './DirectoryPage';
app.initializers.add('voucha-engagement', () => {
  app.routes['voucha-engagement.centre'] = {
    path: '/engagement',
    component: EngagementPage
  };
  app.routes['voucha-engagement.directory'] = {
    path: '/voucha-team',
    component: DirectoryPage
  };

  // "Engagement Centre" in your account menu (only for people allowed to use it)
  extend('flarum/forum/components/SessionDropdown', 'items', function (items) {
    if (!app.forum.attribute('vouchaEngagement')) return;
    items.add('vouchaEngagement', m(LinkButton, {
      icon: "fas fa-people-arrows",
      href: app.route('voucha-engagement.centre')
    }, "Engagement Centre"), 55);
  });

  // Profile card (profile page and the card that opens from a name on a post): short AI-writing note (links to the directory for moderators/admins only)
  extend('flarum/forum/components/UserCard', 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user || !user.attribute('vouchaManaged')) return;
    items.add('vouchaManaged', app.forum.attribute('vouchaTeamDirectory') ? m("a", {
      className: "VouchaManagedNote",
      href: app.route('voucha-engagement.directory')
    }, "May use AI-assisted writing") : m("span", {
      className: "VouchaManagedNote"
    }, "May use AI-assisted writing"), 100);
  });
});